import { Suspense } from 'react';

// material-ui
import Box from '@mui/material/Box';

// project imports
import Loader from './Loader';

// While a page's chunk loads: the progress bar (fixed to the top) and a
// screen-tall empty box. Without the box the fallback has no height, so the
// dashboard footer sat on screen until the page arrived and then jumped below
// it, a layout shift on every page load (Lighthouse, ~0.085 on phones).
const fallback = (
  <>
    <Loader />
    <Box aria-hidden sx={{ minHeight: '100vh', width: 1 }} />
  </>
);

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={fallback}>
      <Component {...props} />
    </Suspense>
  );
};

export default Loadable;
